import type { Icon } from '@phosphor-icons/react';
import { GRUPPEN, type GruppenKey, type WidgetDef } from '../../../../lib/immobilien/widgetRaster';
import { alleEinblenden, anzahlSichtbar, scopeZuruecksetzen, schalteWidget, type Ausgeblendet, type WidgetScope } from '../../../../lib/immobilien/widgetSichtbarkeit';
import { IosSwitch } from '../../../../components/immobilien/ui';

/**
 * „Widgets anpassen“ (README §5.2, Screen 08/38): je Gruppe eine Karte mit Schaltern.
 * Gilt für alle Objekte (Scope o) bzw. alle Einheiten (Scope u).
 */
export function WidgetBearbeiten({ scope, defs, ausgeblendet, onChange, gruppenIcons }: {
  scope: WidgetScope;
  defs: readonly WidgetDef[];
  ausgeblendet: Ausgeblendet;
  onChange: (h: Ausgeblendet) => void;
  gruppenIcons: Record<GruppenKey, Icon>;
}) {
  const sichtbar = anzahlSichtbar(ausgeblendet, scope, defs.map(d => d.key));
  const knopf = { height: 32, padding: '0 12px', borderRadius: 11, border: 'none', fontSize: 12, fontWeight: 700, background: 'var(--fill2)', color: 'var(--ink)' } as const;
  return (
    <section aria-label="Widgets anpassen" className="immo-glas immo-side-in flex flex-col" style={{ borderRadius: 26, padding: 18, gap: 16 }}>
      <div className="flex justify-between items-center flex-wrap" style={{ gap: 10 }}>
        <div className="flex flex-col" style={{ gap: 2 }}>
          <span style={{ fontSize: 16, fontWeight: 800 }}>Widgets anpassen</span>
          <span style={{ fontSize: 12, color: 'var(--ink3)' }}>{scope === 'o' ? 'Gilt für alle Objekte' : 'Gilt für alle Einheiten'} · {sichtbar} von {defs.length} sichtbar</span>
        </div>
        <div className="flex" style={{ gap: 6 }}>
          <button type="button" className="immo-hover-flaeche cursor-pointer" style={knopf} onClick={() => onChange(alleEinblenden(ausgeblendet, scope))}>Alle einblenden</button>
          <button type="button" className="immo-hover-flaeche cursor-pointer" style={knopf} onClick={() => onChange(scopeZuruecksetzen(ausgeblendet, scope))}>Standard</button>
        </div>
      </div>
      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(230px,1fr))', gap: 12 }}>
        {GRUPPEN.map(g => {
          const eintraege = defs.filter(d => d.gruppe === g.key);
          if (eintraege.length === 0) return null;
          const IconKomp = gruppenIcons[g.key];
          return (
            <div key={g.key} className="immo-innen flex flex-col" style={{ borderRadius: 18, padding: 12, gap: 4 }}>
              <span className="flex items-center" style={{ gap: 6, fontSize: 12, fontWeight: 800, color: 'var(--ink3)', padding: '2px 4px 6px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                <IconKomp weight="bold" size={13} />{g.label}
              </span>
              {eintraege.map(d => {
                const an = !ausgeblendet[scope][d.key];
                return (
                  <div key={d.key} onClick={() => onChange(schalteWidget(ausgeblendet, scope, d.key))}
                    className="immo-hover-flaeche flex items-center justify-between cursor-pointer" style={{ gap: 8, padding: '7px 6px 7px 8px', borderRadius: 11 }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: an ? 'var(--ink)' : 'var(--ink3)' }}>{d.label}</span>
                    <IosSwitch klein an={an} label={`${d.label} anzeigen`} onChange={() => onChange(schalteWidget(ausgeblendet, scope, d.key))} />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </section>
  );
}
